<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.userMenuManagement") }}</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <tbody>
          <tr>
            <th>ID</th>
            <td>
              {{ mem.loginId }}
            </td>
            <th>{{ $t("management.usageStatus") }}</th>
            <td>
              {{
                mem.activeFlag == "1"
                  ? $t("management.approved")
                  : $t("management.disApproved")
              }}
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.name") }}</th>
            <td>{{ mem.userName }}</td>
            <th>e-Mail</th>
            <td>{{ mem.emailAddress }}</td>
          </tr>
          <tr>
            <th>{{ $t("management.position") }}</th>
            <td></td>
            <th>{{ $t("management.userType") }}</th>
            <td>
              {{
                mem.userDiv == "1"
                  ? $t("management.employees")
                  : mem.userDiv == "2"
                  ? $t("management.dealer")
                  : $t("management.userRole")
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--------------------------------  메뉴 변경 저장 --------------------------------------------------------->
    <div class="p-2" style="text-align: right">
      <router-link to="/management/user" class="btn btn-outline-dark btn-md m-1">{{
        $t("common.list")
      }}</router-link>
      <button type="button" @click="userMenuMgmt" class="btn btn-primary btn-md m-1">
        {{ $t("common.add") }}
      </button>
      <button type="button" @click="saveUserMenu" class="btn btn-primary btn-md m-1">
        {{ $t("common.save") }}
      </button>
      <button type="button" @click="deleteRole" class="btn btn-secondary btn-md m-1">
        {{ $t("common.delete") }}
      </button>
    </div>
    <!-----------------------------------  메뉴  -------------------------------------------------->
    <div class="brick_box" style="overflow: auto; height: 450px">
      <table class="list_tbl menu_table">
        <thead>
          <tr>
            <th class="mobile_h">
              <input
                type="checkbox"
                @click="goCheckAll($event.target.checked)"
                v-model="checkAll"
              />
            </th>
            <th class="mobile_row">{{ $t("management.menu") }}</th>
            <th class="mobile_row">{{ $t("management.url") }}</th>
          </tr>
        </thead>
        <tbody v-if="userMenuList != null">
          <tr v-for="(menu, index) in userMenuList" :key="index">
            <td>
              <input type="checkbox" v-model="menu.selected" />
            </td>
            <td :id="menu.label">{{ menu.label }}</td>
            <td>{{ menu.menuUrl }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">{{ $t("common.noData") }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!---------------------------------메뉴 추가------------------------------------------->
    <MenuModal id="menuModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("management.menuSetting") }}</h3>
      </template>
      <template slot="body">
        <div class="bg-white p-3 m-3" style="overflow: auto; height: 400px">
          <a-tree
            :replaceFields="replaceFields"
            :treeData="treeData"
            v-model="checkedKeys"
            :checkable="true"
            defaultExpandAll
            @check="onCheck"
          />
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getSelected" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </MenuModal>
  </section>
</template>

<script>
import { getUserDetail } from "@/api/user";
import {
  getUserMenuList,
  getMgmtMenuList,
  deleteUserRoleMenuList,
  saveUserRoleMenu,
} from "@/api/menu";
import MenuModal from "@/components/modal/MenuModal";
export default {
  components: {
    MenuModal,
  },
  data() {
    return {
      mem: "",
      loginId: "",
      roleId: "",
      roleList: [],
      newAuth: [],
      userRoleList: [],
      userMenuList: [],
      form: {
        page: 1,
        roleId: "",
        roleName: "",
      },
      pagingVO: "",
      confirmYN: false,
      checkAll: false,
      parentMenu: [],
      childMenu: [],
      thridMenu: [],
      allMenuList: [],
      allParentMenu: [],
      allChildMenu: [],
      deleteList: [],
      children: [],
      parent: [],
      items: [],
      treeData: [],
      replaceFields: {
        title: "name",
        key: "id",
        Pid: "pid",
      },
      checkedKeys: [],
      showModal: false,
    };
  },
  methods: {
    reset() {
      this.deleteList = [];
      this.mem = {};
      this.roleList = [];
      this.parentMenu = [];
      this.childMenu = [];
      this.userMenuList = [];
      this.treeData = [];
      this.checkedKeys = [];
      this.checkAll = false;
      (this.showModal = false), this.fetchData();
    },
    async fetchData() {
      try {
        this.loginId = this.$route.params.loginId;
        const { data } = await getUserDetail(this.loginId);
        // 사용자 정보
        this.mem = data.member;
        this.roleList = data.member.roleList;
        for (let i in this.roleList) {
          if (this.roleList[i].roleId.substring(0, 2) == "R_") {
            this.roleId = this.roleList[i].roleId;
          }
        }
        const response = await getUserMenuList(this.mem);
        this.parentMenu = response.data.parentMenu;
        this.childMenu = response.data.childMenu;
        this.userMenuList = response.data.userMenuList;
      } catch (error) {
        console.log(error);
      }
    },
    //사용자 메뉴 관리 팝업
    async userMenuMgmt() {
      try {
        const { data } = await getMgmtMenuList("1");
        this.list = data.allMenuList;
        this.parent = data.parentMenu;
        this.children = data.childMenu;
        this.thridMenu = data.thridMenu;

        this.items = data.parentMenu;
        for (let i in this.parent) {
          this.items[i].children = [];
          for (let j in this.children) {
            if (this.parent[i].id == this.children[j].pid) {
              let node = this.children[j];
              node.children = [];
              for (let a in this.thridMenu) {
                if (this.children[j].id == this.thridMenu[a].pid) {
                  node.children.push(this.thridMenu[a]);
                }
              }

              this.items[i].children.push(node);
            }
          }
        }

        this.treeData = this.items;
        this.showModal = true;
      } catch (error) {
        console.log(error);
      }
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    // 선택한 메뉴 기존 리스트에 추가
    getSelected() {
      for (let j in this.list) {
        for (let i in this.checkedKeys) {
          if (this.list[j].id == this.checkedKeys[i]) {
            this.list[j].crudType = "I";
            this.list[j].roleId = this.roleId;
            this.list[j].menuId = this.checkedKeys[i];
            this.list[j].label = this.list[j].name;
            this.list[j].parentMenuId = this.list[j].pid;
            this.userMenuList.push(this.list[j]);
          }
        }
      }
      this.showModal = false;
    },
    // 체크한 menu 삭제
    async deleteRole() {
      for (let i in this.userMenuList) {
        if (this.userMenuList[i].selected) {
          this.deleteList.push(this.userMenuList[i]);
        }
      }
      if (this.deleteList.length > 0) {
        this.confirmYN = confirm(this.$t("alert.delete"));
        if (this.confirmYN) {
          try {
            const { data } = await deleteUserRoleMenuList(this.deleteList);
            if (data.status) {
              alert(this.$t("alert.deletedSuccessfully"));
              this.reset();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          this.deleteList = [];
          return;
        }
      }
    },
    // 메뉴 변경 사항 저장
    async saveUserMenu() {
      if (!confirm(this.$t("alert.save"))) return;
      if (this.roleId == "") {
        alert(this.$t("alert.noAuthorityToAdd"));
        return;
      }
      try {
        const { data } = await saveUserRoleMenu(this.userMenuList);
        if (data.status) {
          alert(this.$t("alert.changedSuccessfully"));
          this.reset();
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    closeModal() {
      this.showModal = false;
    },
    goCheckChild(id, checked) {
      if (checked == true) {
        this.childChecked = id;
      } else {
        this.childChecked = "";
      }
    },
    goOpenChild(parentId) {
      if (this.clickParent == parentId) {
        this.clickParent = "";
      } else {
        this.clickParent = parentId;
      }
    },
    // 전체선택
    goCheckAll(checked) {
      this.checkAll = checked;
      for (let i in this.userMenuList) {
        this.userMenuList[i].selected = this.checkAll;
      }
    },
    // role 검색
    searchBtn() {
      this.form.page = 1;
      this.getUserRole();
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.getUserRole();
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped>
.menu_table tbody tr td {
  text-align: left !important;
}
</style>
